module.exports = {
    gameNetworkId: 117
};



//////////////////
// WEBPACK FOOTER
// ./cfg/game-config.js
// module id = 27
// module chunks = 0